<template>
  <section id="uti-panel-selected" class="selected-test-preview">
    <div>
      <ul>
        <li
          v-for="(category, index) of getCaseCategoryData(test.case_type_code)"
          :key="index"
        >
          <h3 class="test-group-title">
            {{ category.category }}
          </h3>
          <ul>
            <li
              v-for="(item, index) of getCategoryWiseTestsData(
                category.case_type_code,
                category.category_code
              )"
              :key="index"
            >
              <span>
                {{ item.name }}
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      UTIPanels: [],
      selectedUTIPanels: [],
      testsData: [],
      existed: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      allTests: "",
    };
  },
  async mounted() {
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;
    try {
      await this.$store.dispatch("cases/fetchCoriellTestsOfPanel", {
        lab_id: this.getUserPrimaryLabId,
        case_type: "UTI",
      });
      this.UTIPanels =
        this.getCorriellTestPanels && this.getCorriellTestPanels.data
          ? this.getCorriellTestPanels.data
          : [];

      this.setSelectedCoriellPanels();

      // eslint-disable-next-line no-empty
    } catch (err) {
      console.log(err);
    }

    this.testsData = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedTestIds)
    );
    this.selectedCoriellPanels = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedCoriellPanels)
    );
  },
  computed: {
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
    ...mapGetters("cases", ["getCaseInformation", "getCorriellTestPanels"]),
    ...mapGetters("auth", ["getAuthenticatedUser","getUserPrimaryLabId"]),
    checkLabPanels() {
      if (this.selectedUTIPanels && this.selectedUTIPanels.length) {
        return true;
      }
      return false;
    },

    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }

      return data;
    },
  },
  methods: {
    setSelectedCoriellPanels() {
      this.selectedUTIPanels = [];
      this.existed = [...this.panelsTestsData.selectedCoriellPanels];
      let selectedWoundPanelValue =
        this.panelsTestsData.selectedCoriellPanels.find(
          (e) => e.case_type === "UTI"
        );

      if (selectedWoundPanelValue) {
        selectedWoundPanelValue.test_panels.forEach((panel) => {
          let selectedWoundPanel = this.UTIPanels.find((x) => x.code == panel);
          this.selectedUTIPanels.push(selectedWoundPanel);
        });
      }
    },

    getCategoryWiseTestsData(caseType, category) {
      const data = this.selectedTestsDetails.filter(
        (el) => el.case_type_code === caseType && el.category_code === category
      );
      return data;
    },
    getCaseCategoryData(caseType) {
      const data = this.selectedTestsDetails.filter(
        (el) => el.case_type_code === caseType
      );

      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].category_code]) continue;
        flags[data[i].category_code] = true;
        output.push(data[i].category_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },

    // selecting tests based on UTI coriell panels
  },
};
</script>
<style lang="scss"></style>
